// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2DXRU","gradentText":"style_gradentText__2vcY5"};